import React from "react";

type Props = {
  children: React.ReactNode;
  fallback?: (args: { error: unknown; reset: () => void }) => React.ReactNode;
  onError?: (error: unknown, info: React.ErrorInfo) => void;
};

type State = { hasError: boolean; error: unknown };

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: unknown) {
    return { hasError: true, error };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    this.props.onError?.(error, info); // send to Sentry/NewRelic, etc.
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return this.props.fallback
        ? this.props.fallback({ error: this.state.error, reset: this.reset })
        : (
          <div role="alert" style={{ padding: 16 }}>
            <h3>Something went wrong.</h3>
            <pre style={{ whiteSpace: "pre-wrap" }}>{String(this.state.error)}</pre>
          </div>
        );
    }
    return this.props.children;
  }
}
